import update from 'immutability-helper';

import { createStore } from 'redux'

const initialState = {
  sidebarShow: 'responsive',
  apiUser: 0,
  qrCalificacionRespuestas: [],
  qrPromocionCanjes: [],
  ordenPayPal: {},
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      console.log("case.set: type=" + type + " / rest=" + JSON.stringify(rest));
      return { ...state, ...rest }
    case 'SET_API_USER':
      return update(state, { apiUser: { $set: rest.apiUser } });
    case 'SET_QR_CALIFICACION_RESPUESTAS':
      return update(state, { qrCalificacionRespuestas: { $set: rest.qrCalificacionRespuestas } });
    case 'SET_QR_PROMOCION_CANJES':
      return update(state, { qrPromocionCanjes: { $set: rest.qrPromocionCanjes } });
    case 'SET_ORDEN_PAYPAL':      
      return update(state, { ordenPayPal: { $set: rest.ordenPayPal } });
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
